<!-- prettier-ignore -->

<form [ngClass]="{'registerStyle': isBefore || isAfterStandalone, 'SendRouteRegisterStyle': isAfter}" [formGroup]="registerForm">
    <div class="registerStyleContent" style="width: 100%;"> 
        <div *ngFor="let data of formData; let indexForm = index">
            <div class="countryRegister marginRegister" *ngIf="countries && data.type == 'country'" style="text-align: center;">
                <h5 class="h5style">
                    {{'¿Desde dónde nos visitas?' | translate}}
                    <span *ngIf="data.required" class="required-label" [ngClass]="{'has-error': isError() && f?.[data.key]?.errors}">*</span>
                </h5>
                <fieldset class="register_checkbox-group">
                    <div *ngFor="let lang of defaultRegisterLangs" class="register_checkbox">
                        <label class="register_checkbox-wrapper">
                            <input (focusin)="focusin($event)" type="radio" [formControlName]="data.key" [checked]="registerForm.value[data.key] == lang.code" [value]="lang.code" class="register_checkbox-input langsChexBox" (change)="getData()"  />
                            <span class="register_checkbox-tile" [ngClass]="{'has-error': isError() && f?.[data.key]?.errors}">
                            @if(headerLangType() === 'flags'){
                                <span class="register_checkbox-icon">
                                    <img draggable="false" [alt]="lang.icon" [src]="apiUrlBase + '/langs/' + lang.icon + '.svg'" class="flag" />
                                </span>
                            }
                            <span class="register_checkbox-label">{{lang.name}}</span>
                            </span>
                        </label>
                    </div>
                </fieldset>
                <h5 class="h5style">{{'Más opciones:' | translate}}</h5>
                <select id="otherLangs" class="inputsBoxs registerBeforeItem" 
                    [formControlName]="data.key" 
                    [ngStyle]="{width: (isBefore || isAfterStandalone) ? '300px' : '100%'}" (change)="getData()"
                    [ngClass]="{'has-error': isError() && f?.[data.key]?.errors}"
                >
                        <option value="" selected="selected">{{'Selecciona Pais...' | translate}}</option>
                        <ng-container *ngFor="let country of countries" >
                            <option *ngIf="!defaultRegisterLangsArray.includes(country.iata)" [selected]="registerForm.value[data.key] == country.iata"  [value]="country.iata">{{country.name}}</option>
                        </ng-container>
                </select>
            </div>

            <div class="registerBeforeType marginRegister" [ngClass]="(isBefore || isAfterStandalone) ? 'alignRegisterCenter' : 'alignRegisterLeft'" *ngIf="data.type == 'text'">
                <h5 class="registerBeforeText h5style">
                    {{data.title | translate}}
                    <span *ngIf="data.required" class="required-label" [ngClass]="{'has-error': isError() && f?.[data.key]?.errors}">*</span>
                </h5>
                <input type="text" class="inputsBoxs registerBeforeItem"
                    (focusin)="focusin($event)" 
                    [formControlName]="data.key"  
                    [ngStyle]="{width: (isBefore || isAfterStandalone) ? '300px' : '100%'}" (keyup)="getData()" 
                    [ngClass]="{'has-error': isError() && f?.[data.key]?.errors}"
                />
            </div>

            <div class="registerBeforeType marginRegister" [ngClass]="(isBefore || isAfterStandalone) ? 'alignRegisterCenter' : 'alignRegisterLeft'" *ngIf="data.type == 'cp'" style="text-align: center;">
                <h5 class="registerBeforeText h5style">
                    {{'Código Postal' | translate}}
                    <span *ngIf="data.required" class="required-label" [ngClass]="{'has-error': isError() && f?.[data.key]?.errors}">*</span>
                </h5>
                <input type="text" class="inputsBoxs registerBeforeItem" 
                    [formControlName]="data.key"
                    [ngStyle]="{width: (isBefore || isAfterStandalone) ? '300px' : '100%'}" (keyup)="getData()"
                    (focusin)="focusin($event)" 
                    [ngClass]="{'has-error': isError() && f?.[data.key]?.errors}"
                />
            </div>

            <div class="registerBeforeType marginRegister" [ngClass]="(isBefore || isAfterStandalone) ? 'alignRegisterCenter' : 'alignRegisterLeft'" *ngIf="provinces && data.type == 'province'">
                <h5 class="registerBeforeText h5style">
                    {{'Provincia' | translate}}
                    <span *ngIf="data.required" class="required-label" [ngClass]="{'has-error': isError() && f?.[data.key]?.errors}">*</span>
                </h5>
                <select class="inputsBoxs registerBeforeItem" 
                    [formControlName]="data.key" 
                    [ngStyle]="{width: (isBefore || isAfterStandalone) ? '300px' : '100%'}" 
                    (change)="getData()"
                    [ngClass]="{'has-error': isError() && f?.[data.key]?.errors}"
                >
                        <option value="" selected="selected">{{'Selecciona Provincia...' | translate}}</option>
                        <option *ngFor="let province of provinces" [value]="province.name">{{province.name}}</option>
                </select>
            </div>

            <div class="registerBeforeType marginRegister" [ngClass]="(isBefore || isAfterStandalone) ? 'alignRegisterCenter' : 'alignRegisterLeft'" *ngIf="data.type == 'selection_unique'" >
                <h5 class="registerBeforeText h5style">
                    {{data.title | translate}}
                    <span *ngIf="data.required" class="required-label" [ngClass]="{'has-error': isError() && f?.[data.key]?.errors}">*</span>
                </h5>
                <div class="selectionRegister">
                    <div *ngFor="let option of data.options" class="moreRegisterPage radio-image" style="display: flex; flex-direction: row; margin-top: 10px; position: relative; margin-left: 6px;" >
                        <input type="radio" (focusin)="focusin($event)" [value]="option" [formControlName]="data.key" [name]="data.key" (change)="setSelectedOption(option, data.key)" class="inputs-checkbox-register"  />
                        <span class="checkmarkPage" [ngClass]="{'has-error': isError() && f?.[data.key]?.errors}"></span>
                        <label class="labelsRegister">{{option | translate}}</label>
                    </div>
                </div>
            </div>

            <div class="registerBeforeType marginRegister" [ngClass]="(isBefore || isAfterStandalone) ? 'alignRegisterCenter' : 'alignRegisterLeft'" *ngIf="data.type == 'selection_multi'" >
                <h5 class="registerBeforeText h5style">
                    {{data.title | translate}}
                    <span *ngIf="data.required" class="required-label" [ngClass]="{'has-error': isError() && f?.[data.key]?.status === 'INVALID'}">*</span>
                </h5>
                <div [formArrayName]="data.key" class="selectionRegister">
                    <div *ngFor="let option of getMultiControls(data.key)" class="moreRegisterPage radio-image" style="display: flex; flex-direction: row; margin-top: 10px; position: relative; margin-left: 6px;" >
                        <input type="checkbox" (focusin)="focusin($event)" [formControl]="$any(option.get('selected'))" class="inputs-checkbox-register" (change)="getData()" />
                        <span class="checkmarkPage" [ngClass]="{'has-error': isError() &&  f?.[data.key]?.status === 'INVALID'}"></span>
                        <label class="labelsRegister">{{  option.get('value').value | translate}}</label>
                    </div>
                </div>
            </div>
            
        </div>

    </div>
</form>